import { Divider, Icon, Logo, MultiClickZone, Text, Theme, useIsTheme } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { Country } from '@afterpaytouch/portal-api/types'
import styles from './style.module.css'
import { Route } from '../../config/router'
import { useRouter } from 'next/router'
import { CLICKS_TO_REVEAL_SESSION_ID, SessionIdVisibility } from '../../model'
import { useSessionId, useAppDispatch } from '../../state'
import { setSessionIdVisibility } from '../../state/identity/reducer'

export interface HeaderProps {
  country?: Country
  testNameSpace?: string
  isHideClose?: boolean
  hideTagline?: boolean
}

const I18N_NAMESPACE = ['common']

export const Header: FunctionComponent<HeaderProps> = ({ country, testNameSpace = '', isHideClose, hideTagline = false }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const route = useRouter()
  const isCashTheme = useIsTheme(Theme.Cash)
  const dispatch = useAppDispatch()
  const { visibility: sessionIdVisibility } = useSessionId()

  const showTagline = typeof country === 'undefined' || isCashTheme || hideTagline ? false : ![Country.US, Country.AU].includes(country)

  const onMultiClickTrigger = (): void => {
    const newVisibility = sessionIdVisibility === SessionIdVisibility.VISIBLE ? SessionIdVisibility.HIDDEN : SessionIdVisibility.VISIBLE
    dispatch(setSessionIdVisibility(newVisibility))
  }

  return (
    <header>
      <div className={styles.header} {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-header` })}>
        <div className={styles.headerBody}>
          <div className={styles.standardHeader}>
            <div className={styles.headerLogoRow}>
              <MultiClickZone onMultiClickTrigger={onMultiClickTrigger} testNameSpace='header' numOfClicks={CLICKS_TO_REVEAL_SESSION_ID} />
              <Logo name={t('common:brandName')} title={t('common:brandName')} description={t('common:brandName')} size={showTagline ? 'Small' : 'Medium'} />
            </div>
            {showTagline && (
              <div className={styles.taglineWrapper}>
                <Text size='M' testNameSpace='tagline'>
                  {t('common:tagline')}
                </Text>
              </div>
            )}
          </div>
        </div>
        {isHideClose !== true && (
          <button
            type='button'
            className={styles.closeWrapper}
            onClick={() => {
              route.push(Route.HOME)
            }}
            aria-label={t('common:close')}
          >
            <Icon.Close size='Small' />
          </button>
        )}
      </div>
      <Divider kind='Hairline' />
    </header>
  )
}
